import { render } from "./step-proof.vue?vue&type=template&id=1c15c23c"
import script from "./step-proof.vue?vue&type=script&lang=js"
export * from "./step-proof.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__